"use strict";
var editor_2d = require("editor-2d");
var lib_core = require("lib-core");
var HandleView = require("./../../../interactionViews/handleView.js");
var drawTextDataTo2D = require("./../../../view/renderData/drawTextDataTo2D.js");

var TextInteractionView = function (gui, interactionModel, parentGroup, layers) {
    var self = this;
    this.gui = gui;
    this.interactionModel = interactionModel;
    this.data = interactionModel.data;

    this.cameraModel = this.gui.editorModel.cameraModel();

    this.initGroups(parentGroup, [layers.draw, layers.control]);

    this.elementSvgGroup = this.getGroupInfo(layers.draw).svgGroup;
    this.controlGroup = this.getGroupInfo(layers.control).svgGroup;

    $(this.controlGroup).mousedown(function(event){
        var cEvent = self.getMouseDownEvent(event);
        return self.gui.stateMachine.handle(cEvent);
    });

    if(this.interactionModel.handle) {
        this.handle = new HandleView(self, this.gui, 0, this.interactionModel.handle(), parentGroup, layers);
    }

    this.draw();

    if(this.interactionModel) {
        this.interactionModel.selected.onChange(this, function (value) {
            self.setSelected(value);
        }, 10);
    }

    this.data.onBubble(this, function () {
        self.gui.heavyHandler.scheduleHeavy('rebuild_view', self.draw, self, [], self);
    }, 10);

    this.cameraModel.viewS.onChange(self, function(){
        self.gui.heavyHandler.scheduleHeavy('expand_control', self.resizeControl, self, [], self);
    },10);
};
lib_core.mixin(TextInteractionView, editor_2d.DrawingElement);

module.exports = TextInteractionView;

TextInteractionView.prototype.draw = function () {
    var self = this;

    $(this.elementSvgGroup).empty();
    $(this.controlGroup).empty();

    if(!this.data.isAlive()) return;

    // draw visible
    drawTextDataTo2D(this.gui.svg, this.elementSvgGroup, this.data, this.interactionModel.mirrored());

    // draw control
    drawTextDataTo2D(this.gui.svg, this.controlGroup, this.data, this.interactionModel.mirrored());
    this.control = $(":nth-last-child(1)", this.controlGroup);
    this.resizeControl();
};

TextInteractionView.prototype.resizeControl = function (event) {
    if(this.control) this.control.attr("stroke-width", this.data.strokeWidth() + 4 / this.cameraModel.viewS());
};

TextInteractionView.prototype.getMouseDownEvent = function (event) {
    var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.ELEMENT_MOUSE_DOWN)
        .fromJSEvent(event)
        .element( this.interactionModel )
        .data( 'mouseCoord', this.gui.relativeMouseCoord(event) );

    return cEvent;
};
